import SiteUDFCustomerModel from "../../models/site-udf-customer/site-udf-customer.model";
import MultiSelectComponent from "../multi-select/multi-select.component";
import SingleSelectComponent from "../single-select/single-select.component";

/**
 * Select Site UDF Customer Component
 * 
 * @author Leong CV 
 */
export default function SelectSiteUDFCustomerComponent() {
  let selectOptions = [];

  return {
    oninit: () => {
      SiteUDFCustomerModel.getCustomerList()
        .then(data => {
          selectOptions = data || [];
        })
    },
    view: ({ attrs: { filterableByKey = true, items, isMultiple = true, ...props } }) => {
      return [
        isMultiple
          ? m(MultiSelectComponent, {
            filterableByKey,
            itemKey: 'customerCode',
            itemValue: 'customerName',
            items: selectOptions,
            ...props,
          })
          : m(SingleSelectComponent, {
            filterableByKey,
            itemKey: 'customerCode',
            itemValue: 'customerName',
            items: selectOptions,
            ...props,
          })
      ]
    }
  }
}
